//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div style="width:100%; float:left">
    <div style="float:left">
      <p style="font-size:16px; padding-top:0px;">Клиенты</p>
    </div>
    <div style="margin-top:-5px; padding-left:5px; float:left">
      <Button type="text" size="small" style="border-radius:3px; margin-bottom:5px; padding-top:5px;" @click="reloadOnClick">
        <Icon type="ios-loop" size="18"></Icon>
      </Button>
    </div>
    <div style="float:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="dashed" style="border-radius:3px; height:36px; margin-bottom:0px; color:#b7b7b7; text-decoration2:underline;" size2="large" @click="showDeletedItemsChangeMode"><span v-if="showDeletedItemsMode==false">АРХИВ</span><span v-else>ВЕРНУТЬСЯ ИЗ АРХИВА</span></Button>
    </div>
  </div>

  <div v-if="commonData.isLoaded == false">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="dataIsLoaded == false">
    Подождите, загружаются данные по клиентам
  </div>
  <div v-else style="width:100%; float:left">

   <div :style="expandTable == true ? 'width:100%' : 'width:calc(100% - 370px)'" style="height:100%; padding-right:0px; float:left;">

    <div style="width:50px; padding-top:11px; padding-bottom:0px; display:inline-block; float:left;"><span>Фильтр</span></div>
    <div style="padding-bottom:12px; display:inline-block; width:300px">
      <Input v-model="filterValue" size="large" style="width:100%" v-on:on-change="filterValueOnChange"/>
    </div>

    <div style="float2:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="ghost" style="border-radius:3px; height:36px; margin-bottom:0px;" size="large" :disabled="(editingDataRow != null) && (editingDataRow.val.id == null)" @click="newEditingDataRowOnClick">+</Button>
    </div>

    <div v-if="showDeletedItemsMode == true" style="font-size:15px; padding-bottom:10px">
      АРХИВ КЛИЕНТОВ:
    </div>

    <div v-if="filteredRecords.length > 0">
     <div v-for="(itemData, keyData) in filteredRecords" :key="keyData" style="width:350px; height:180px; padding:20px; margin:0 10px 10px 0; border-radius:10px; float:left;"
      :style="{border: isRowSelected(itemData) == true ? '1px solid #bbb' : '1px solid #ccc',
              color: isRowSelected(itemData) == true ? '#fff' : '#778087',
              background: isRowSelected(itemData) === true ? '#a0a7ff' : (itemData.val.ClientOrSupplier !== 1 ? '#cccce0' : (itemData.val.PersonOrCompany === 1 ? '#cec' : '#eee'))}"
      @click="dataRowOnSelect(itemData)">

      <div style="margin:0px 0 10px 0; padding-bottom:5px; display:inline-block; float:left; width:calc(100% - 20px)"><span style="font-size:18px"><b>{{itemData.val.Name}}&nbsp;</b></span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:20px">
        <div v-if="itemData.val.PersonOrCompany === 2"><Icon type="briefcase" style="font-size:19px"/></div>
        <div v-else><Icon type="android-contact" style="font-size:19px"/></div>
      </div>

      <div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>ИНН</span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)"><span>{{itemData.val.INN}}&nbsp;</span></div>

      <div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>Телефон</span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)"><span>{{itemData.val.Phone}}&nbsp;</span></div>

      <div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span v-if="itemData.val.PersonOrCompany === 2">Контактное лицо</span>&nbsp;</div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)"><span v-if="itemData.val.PersonOrCompany === 2">{{itemData.val.ContactName}}</span>&nbsp;</div>

      <div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>Город</span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)"><span>{{itemData.val.City}}&nbsp;</span></div>

      <div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>Адрес</span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)"><span>{{itemData.val.Address}}&nbsp;</span></div>

      <!--div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;" v-if="itemData.val.PersonOrCompany === 1"><span>День рождения</span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)" v-if="itemData.val.PersonOrCompany === 1"><span>{{itemData.val.Birthday}}&nbsp;</span></div-->

      <!--div style="width:120px; padding-top:0px; padding-bottom:0px; display:inline-block; float:left;"><span>Номер карты</span></div>
      <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 120px)"><span>{{itemData.val.CardNumber}}&nbsp;</span></div-->

      <div style="margin-top:5px; padding-bottom:5px; display:inline-block; clear:left; width:100%;">
        <span v-if="itemData.val.ClientOrSupplier !== 1" style="float:right;"><b>ПОСТАВЩИК</b></span>&nbsp;
      </div>

      <!--hr style="margin:10px 0px 10px 0px; border-top-width:1px; border-top-color:#b7c0c7; width:400px; display:inline-block; clear:left;" /-->

     </div>

     <div v-if="filteredRecords.length == numOfItemsToShowWithEmptyFilter" style="clear:left">
       * Список не полный, еще много всего найдено. Используйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
     </div>
    </div>

    <div v-else>
      * Ничего не найдено. Скорректируйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
    </div>

   </div>

   <div style="width:370px; padding: 44px 0px 10px 20px; border-left:1px solid #ccc; float:left; min-height: calc(100vh - 130px)" :class="(expandTable == true) ? 'hidden' : ''">

     <div v-if="editingDataRow != null">

        <div style="width:100%; padding-top:5px; padding-bottom:20px; display:inline-block; float:left;">
          <span v-if="editingDataRow.val.id != null"><b>РЕДАКТИРОВАНИЕ :</b></span>
          <span v-else><b>НОВЫЙ КЛИЕНТ :</b></span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Имя</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.Name" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Человек / компания</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.PersonOrCompany" filterable placeholder="Выберите" style="width:100%; height:32px; background-color:#fff">
            <option value=1>Человек</Option>
            <option value=2>Компания</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Клиент / поставщик</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.ClientOrSupplier" filterable placeholder="Выберите" style="width:100%; height:32px; background-color:#fff">
            <option value=0>Клиент и поставщик</Option>
            <option value=1>Клиент</Option>
            <option value=2>Поставщик</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>ИНН</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.INN" style="width:100%"></Input>
        </div>

        <div v-if="editingDataRow.val.PersonOrCompany == 2">
        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>ОГРНН</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.OGRNN" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>КПП</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.KPP" style="width:100%"></Input>
        </div>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Телефон</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.Phone" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Email</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.Email" style="width:100%"></Input>
        </div>

        <div v-if="editingDataRow.val.PersonOrCompany == 2">
        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Контактное<br>лицо</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.ContactName" style="width:100%"></Input>
        </div>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Город</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.City" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Адрес</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.Address" style="width:100%"></Input>
        </div>

        <!--div v-if="editingDataRow.val.PersonOrCompany == 1">
        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>День рождения</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.Birthday" style="width:100%"></Input>
        </div>
        </div-->

        <!--div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Номер карты</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.CardNumber" style="width:100%"></Input>
        </div-->

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Идентификатор</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          {{editingDataRow.val.id}}&nbsp;
        </div>

        <div style="padding: 15px 0px 0px 0px;">
          <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveEditingDataRowOnClick">Сохранить</Button>
          <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelEditingDataRowOnClick">Отменить</Button>
          <Button type="ghost" style="float:right; border-radius:3px; margin-bottom:10px; padding-top:5px; color:#d7d7d7;" :class="editingDataRow.val.id == null ? 'hidden' : ''" @click="deleteEditingDataRowOnClick">
            <Icon type="trash-b" size="18"></Icon>
            <Icon type="ios-redo" size="18" v-if="editingDataRow.val.Deleted == -1"></Icon>
          </Button>
        </div>

     </div>

     <!--div v-else>
       * Выберите запись для просмотра или редактирования
       <br><br><br>
     </div-->

   </div>

  </div>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import arrayTools from '@/technical/arrayTools/arrayTools'

import serverData from '@/store/serverData'

export default {
  components: { },
  data () {
    return {
      // usersAccessAsOffice: {'5': true, '7': true, '8': true, '11': true, '95': true}, // Тюрин, Ремезова, Малюгина, Егор, Белов

      data: [], // list of Partners
      filteredRecords: [],

      // UI FIELDS
      dataIsLoaded: false,
      numOfItemsToShowWithEmptyFilter: 50,
      showDeletedItemsMode: false,

      filterValue: '',

      expandTable: true,

      loadingSpinner: false,

      selectedDataRow: null,
      editingDataRow: null
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData'
    ])
  },
  created: function () {
    var thisRef = this
    this.data = serverData.partners // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event PartnersChanged
    thisRef.dataIsLoaded = true // !!! т к это CommonData то когда commonData.isLoaded == true то сразу ставим и dataIsLoaded = true

    serverData.partnersOnDestroyDelegates.push(this.deleteDataRecDelegate)

    serverData.eventsBus.$on('partnersChanged', (data) => {
      // console.log('on partnersChanged')
      // console.log(data)
      /* if (this.editingDataRec.val.id === data.record.id) {
        this.editingDataRec.val = Object.assign({}, data.record)
      } */
      if (data.method === 'read') thisRef.dataIsLoaded = true
      thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    })

    // если это не перезагрузка данной страницы то serverData уже давно есть и тут строим список наших отображаемых данных
    thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
  },
  methods: {
    ...mapMutations([
      'commonDataIsLoadedSet'
    ]),
    reloadOnClick () {
      var thisRef = this
      // thisRef.data = [] // трется внутри serverData.reload
      thisRef.dataIsLoaded = false

      serverData.partnersReload(function (err) {
        if (err) return serverErrorHandling(err, thisRef)
        // вместо этих строк работает serverData.eventsBus.$on('partnersChanged', (data))
        // thisRef.data = serverData.partners // data так и смотрела на serverData которые не перезаписывались а стирались и добавлялись
        // thisRef.filterValueOnChange()
      })
    },
    filterValueOnChange () {
      this.filteredRecords.splice(0, this.filteredRecords.length)

      if (this.data.length === 0) return

      for (let i = this.data.length - 1; i >= 0; i--) {
        if ((this.showDeletedItemsMode === false) && (this.data[i].val.Deleted !== 0)) continue // !!! НЕ ИЩЕМ В УДАЛЕННЫХ
        if ((this.showDeletedItemsMode === true) && (this.data[i].val.Deleted !== -1)) continue // !!! НЕ ИЩЕМ НЕ В УДАЛЕННЫХ
        // if ((this.usersAccessAsOffice[this.activeUser.id] !== true) && (this.data[i].val.GroupID === 2)) continue // !!! ИЩЕМ ТОЛЬКО В 'ПОКУПАТЕЛЯХ', не в 'ПОСТАВЩИКАХ' и т.д.

        if (this.filterValue.length < 3) {
          if (this.filteredRecords.length < this.numOfItemsToShowWithEmptyFilter) this.filteredRecords.push(this.data[i])
          continue
        }

        if (this.data[i].val.id.toString().indexOf(this.filterValue) !== -1) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.INN != null) && (this.data[i].val.INN.indexOf(this.filterValue) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.Phone != null) && (this.data[i].val.Phone.indexOf(this.filterValue) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        var filterValueLowerCase = this.filterValue.toLowerCase()
        if ((this.data[i].val.Name != null) && (this.data[i].val.Name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.ContactName != null) && (this.data[i].val.ContactName.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.City != null) && (this.data[i].val.City.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.Address != null) && (this.data[i].val.Address.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
      }

      arrayTools.sort(this.filteredRecords, function (a, b) {
        return a.val.Name > b.val.Name
      })
    },

    newEditingDataRowOnClick () {
      var newEntity = restResource(this.appSettings.server.host + this.appSettings.server.partnerResource)
      newEntity.val = {}
      newEntity.val.Name = ''
      newEntity.val.PersonOrCompany = 2 // Company
      newEntity.val.ClientOrSupplier = 1 // Client
      newEntity.val.INN = ''
      newEntity.val.OGRNN = ''
      newEntity.val.KPP = ''
      newEntity.val.Phone = ''
      newEntity.val.ContactName = ''
      newEntity.val.Email = ''
      newEntity.val.City = ''
      newEntity.val.Address = ''
      newEntity.val.Birthday = ''
      newEntity.val.CardNumber = ''
      newEntity.val.body = null
      newEntity.val.Deleted = 0 // Not deleted

      this.selectedDataRow = null
      this.editingDataRow = Object.assign({}, newEntity)
      this.editingDataRow.val = Object.assign({}, newEntity.val)

      this.expandTable = false // to show newEntity editing
    },

    cancelEditingDataRowOnClick () {
      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
    },

    saveEditingDataRowOnClick () {
      if (this.editingDataRow.val.Name === '') return this.$message.error('Введите имя')
      if (this.editingDataRow.val.INN === '') return this.$message.error('Введите ИНН')
      if (this.editingDataRow.val.Phone === '') return this.$message.error('Введите телефон')

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      thisRef.editingDataRow.save()
      .then(function (response) {
        thisRef.loadingSpinner = false
        loading.close()

        thisRef.selectedDataRow = null
        thisRef.editingDataRow = null
        thisRef.expandTable = true

        /* serverData.partnersReload(function (err) {
          if (err) return serverErrorHandling(err, thisRef)
          thisRef.data = serverData.partners
          thisRef.filterValueOnChange()
        }) */

        // thisRef.$message.success('Запись сохранена на сервер')
      })
      .catch(function (error) {
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(error, thisRef)
      })
    },

    deleteEditingDataRowOnClick () {
      if (this.editingDataRow.val.Deleted === 0) this.editingDataRow.val.Deleted = -1 // delete (archive)
      else this.editingDataRow.val.Deleted = 0 // undelete (return from archive trashbox)

      this.saveEditingDataRowOnClick()
      // this.filterValueOnChange()

      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
    },

    deleteDataRecDelegate (deletedRecord, cb) {
      /* var thisRef = this
      if ((thisRef.editingDataRec != null) && (deletedRecord.id === thisRef.editingDataRec.val.id)) {
        thisRef.editingDataRec = null
      } */
      return cb()
    },

    showDeletedItemsChangeMode () {
      this.showDeletedItemsMode = !this.showDeletedItemsMode
      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
      this.filterValueOnChange()
    },

    dataRowOnSelect (value) {
      this.selectedDataRow = value
      this.editingDataRow = Object.assign({}, value)
      this.editingDataRow.val = Object.assign({}, value.val)
      this.expandTable = false
    },

    isRowSelected (row) {
      if (this.selectedDataRow == null) return false
      if (row.val.id === this.selectedDataRow.val.id) return true
      else return false
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.top-panel-expand-table-button {
  margin: 0px;
  pading: 0px;
  font-size: 17px;
  color: #5a5a5a;
  cursor: pointer;
}
.top-panel-expand-table-button:hover {
  color: #000;
}
.datalist{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.datalist-scroll {
  overflow-y: scroll;   /* надо чтобы работал scroll для mainMenu */
  height: calc(100vh - 200px);
  /* width: 257px; /* минимум на 17 пикселей больше чем mainmenu-panel.width, ща сделал на 50 больше */
}
hr {
  /*border: none; /* Убираем границу для браузера Firefox */
  /*color: #ccc; /* Цвет линии для остальных браузеров */
  /*background-color: #ccc; /* Цвет линии для браузера Firefox и Opera */
  /*height: 1px; /* Толщина линии */
  margin: 10px 0 15px 0;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.incomesAndExpensesTextarea textarea.ivu-input {
  font-size: 12px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Partners.vue?782fae0a